// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: column;
}

.button {
  width: 150px;
  background-color: #d4bed4;
  border: none;
  outline: none;
  height: 40px;
  border-radius: 10px;
  color: #000000;
  text-transform: uppercase;
  font-weight: bold;
  margin: 10px 0;
  cursor: pointer;
  transition: 0.3s;
  background-size: 400% 400%;
  
}

.button:hover {
  transform: translateY(-3px);
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s;
}

.custom-select {
  width: 35%;
  position: relative;
}

@media only screen and (max-width: 600px) {
  .custom-select {
    height: 20px;
    width: 100%;
    margin-top: 10px;
  }
}

.date-input-container {
  display: flex;
  flex-direction: column; /* Adjusted for responsiveness */
  align-items: center;
  gap: 10px; /* Adjusted gap for responsiveness */
}

.search-bar-input {
  max-width: 400px; /* Reduced width */
  width: 100%; /* Ensure it takes full width on smaller screens */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

@media only screen and (max-width: 600px) {
  .search-bar-input {
    max-width: none; /* Remove max-width on smaller screens */
  }
}

.date-input,
.reset-button {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.date-input-container input[type="date"] {
  appearance: none;
}

.reset-button {
  background-color: #4753ff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.reset-button:hover {
  background-color: #90f761;
}

/* Shadow effect */
.date-input-container input[type="text"],
.date-input-container input[type="date"],
.date-input-container button {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

@keyframes gradbar {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;;AAE5B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,gCAAgC;EACxD,mBAAmB;EACnB,SAAS,EAAE,oCAAoC;AACjD;;AAEA;EACE,gBAAgB,EAAE,kBAAkB;EACpC,WAAW,EAAE,kDAAkD;EAC/D,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe,EAAE,wCAAwC;EAC3D;AACF;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EAGE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,8CAA8C,EAAE;EACtD,MAAM,4CAA4C,EAAE;EACpD,MAAM,2CAA2C,EAAE;EACnD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,4CAA4C,EAAE;EACpD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,OAAO,6CAA6C,EAAE;AACxD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["body {\n  font-family: Arial, Helvetica, sans-serif;\n  display: flex;\n  flex-direction: column;\n}\n\n.button {\n  width: 150px;\n  background-color: #d4bed4;\n  border: none;\n  outline: none;\n  height: 40px;\n  border-radius: 10px;\n  color: #000000;\n  text-transform: uppercase;\n  font-weight: bold;\n  margin: 10px 0;\n  cursor: pointer;\n  transition: 0.3s;\n  background-size: 400% 400%;\n  \n}\n\n.button:hover {\n  transform: translateY(-3px);\n  transform: scale(1.05);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.2s;\n}\n\n.custom-select {\n  width: 35%;\n  position: relative;\n}\n\n@media only screen and (max-width: 600px) {\n  .custom-select {\n    height: 20px;\n    width: 100%;\n    margin-top: 10px;\n  }\n}\n\n.date-input-container {\n  display: flex;\n  flex-direction: column; /* Adjusted for responsiveness */\n  align-items: center;\n  gap: 10px; /* Adjusted gap for responsiveness */\n}\n\n.search-bar-input {\n  max-width: 400px; /* Reduced width */\n  width: 100%; /* Ensure it takes full width on smaller screens */\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n@media only screen and (max-width: 600px) {\n  .search-bar-input {\n    max-width: none; /* Remove max-width on smaller screens */\n  }\n}\n\n.date-input,\n.reset-button {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.date-input-container input[type=\"date\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.reset-button {\n  background-color: #4753ff;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.reset-button:hover {\n  background-color: #90f761;\n}\n\n/* Shadow effect */\n.date-input-container input[type=\"text\"],\n.date-input-container input[type=\"date\"],\n.date-input-container button {\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n@keyframes shake {\n  0% { transform: translate(1px, 1px) rotate(0deg); }\n  10% { transform: translate(-1px, -2px) rotate(-1deg); }\n  20% { transform: translate(-3px, 0px) rotate(1deg); }\n  30% { transform: translate(3px, 2px) rotate(0deg); }\n  40% { transform: translate(1px, -1px) rotate(1deg); }\n  50% { transform: translate(-1px, 2px) rotate(-1deg); }\n  60% { transform: translate(-3px, 1px) rotate(0deg); }\n  70% { transform: translate(3px, 1px) rotate(-1deg); }\n  80% { transform: translate(-1px, -1px) rotate(1deg); }\n  90% { transform: translate(1px, 2px) rotate(0deg); }\n  100% { transform: translate(1px, -2px) rotate(-1deg); }\n}\n\n@keyframes gradbar {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
